export { P200ActivationPage as default } from './P200ActivationPage';
